<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div style="padding: 15px;" v-show="showSearch">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">{{ school_name }}</div>
				<div style="height: 50px;"></div>
				<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" />
				<van-field v-model="stuForm.exam_num" label="考试证号" placeholder="请输入考试证号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>
		</div>

		<div style="padding: 15px;" v-show="showInfo">
			<div style="text-align: center; background-color: #fff; padding: 20px;">{{ school_name }}</div>
			<div class="rowlb">
				<span></span>
				个人信息
			</div>
			<van-cell-group>

				<van-field :readonly="true" v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" />

				<van-field :readonly="true" v-model="stuForm.graduate_sch_city" label="手机号" placeholder="毕业地区" />
				<van-field :readonly="true" label="性别">
					<template #input>
						<span style="color: #000000;" v-if="stuForm.gender == 1">男</span>
						<span style="color: #000000;" v-if="stuForm.gender == 2">女</span>
					</template>
				</van-field>

				<van-field :readonly="true" v-model="stuForm.identity_card" label="身份证号" placeholder="身份证号" />



				<van-field :readonly="true" v-model="stuForm.major_name" label="报考专业" placeholder="专业名称" />

				<van-field :readonly="true" label="退费金额" placeholder="退费金额">
					<template #input>
						<span style="color: #000000;"
							v-if="stuForm.fee && stuForm.fee.stu && stuForm.fee.stu.total_money > 0">￥{{
								stuForm.fee.stu.total_money }}</span>
						<span style="color: #000000;" v-else>女</span>

					</template>
				</van-field>
				<div class="rowlb">
					<span></span>
					退费信息
				</div>
				<van-cell title="是否原路退回" required>

					<template #right-icon>
						<van-radio-group v-model="YuanluTuihui" direction="horizontal">
							<van-radio :name="1">是</van-radio>
							<van-radio :name="2">否</van-radio>
						</van-radio-group>
					</template>
				</van-cell>
				<div style="color: orangered; font-size: 12px; text-align: left; margin-left:10px;margin-bottom: 10px;">
					选“是”，退费将原路退回，通过支付宝使用银行卡付款的，将退回到付款银行卡上。从支付宝余额支付的将退回到支付宝余额。
				</div>

				<van-field v-if="YuanluTuihui == 2" v-model="tuifei.bank_card_num" label="银行卡号" placeholder="银行卡号"
					required />
				<van-field v-if="YuanluTuihui == 2" v-model="tuifei.bank_card_type" label="开户行" placeholder="银行卡开户行及支行"
					required />
				<div v-if="YuanluTuihui == 2"
					style="color: orangered; font-size: 12px; text-align: left; margin-left:10px;margin-bottom: 10px;">
					请输入银行支行：xx银行xxx支行；
				</div>
				<div v-if="YuanluTuihui == 2"
					style="color: orangered; font-size: 12px; text-align: left; margin-left:10px; margin-bottom: 10px;">
					若支行信息填写错误将无法收到转账，查询支行信息可拨打银行客服电话或者登录手机银行app查询，请确认之后再提交。
				</div>
				<van-field v-if="YuanluTuihui == 2" v-model="tuifei.bank_card_name" label="银行卡姓名" placeholder="银行卡开卡姓名"
					required />


				<div class="rowlb">
					<span></span>
					附件内容
				</div>
				<van-field name="uploader5" label="身份证正面">
					<template #input>
						<div class="imagebox" @click="setImageType('identity_card1')">
							<van-icon name="photo-o" v-if="!pjson.identity_card1" />
							<img v-else :src="pjson.identity_card1" style="width: 100%; height: 100%;">

						</div>

					</template>
				</van-field>


				<van-field name="uploader5" label="身份证反面">
					<template #input>
						<div class="imagebox" @click="setImageType('identity_card2')">
							<van-icon name="photo-o" v-if="!pjson.identity_card2" />
							<img v-else :src="pjson.identity_card2" style="width: 100%; height: 100%;">

						</div>

					</template>
				</van-field>


				<van-field name="uploader5" label="户口本">
					<template #input>
						<div class="imagebox" @click="setImageType('hkb')">
							<van-icon name="photo-o" v-if="!pjson.hkb" />
							<img v-else :src="pjson.hkb" style="width: 100%; height: 100%;">
						</div>
					</template>
				</van-field>

				<van-field name="uploader5" label="缴费证明">
					<template #input>
						<div class="imagebox" @click="setImageType('jiaofei')">
							<van-icon name="photo-o" v-if="!pjson.jiaofei" />
							<img v-else :src="pjson.jiaofei" style="width: 100%; height: 100%;">
						</div>
					</template>
				</van-field>
				<div class="rowlb" v-if="process_status">
					<span></span>
					退费进度 <div style="float: right; font-size: 12px; color: #007AFF;">{{ process_status }}</div>
				</div>

				<div class="submitBtn flexAround" v-if="showbtn">
					<div class="btn" @click="saveStu()" style="width: 40%;">提交申请</div>
				</div>

				<div style="height:10px;"></div>

			</van-cell-group>
		</div>

	</div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {
	Toast, Dialog
} from 'vant';
export default {
	data() {
		return {
			showSearch: false,
			showInfo: false,
			pmid: 0,
			openid: 0,
			school_name: '',
			YuanluTuihui: 1,
			stuForm: {
				stu_name: "",
				exam_num: ""
			},
			tuifei: {
				bank_card_num: "",
				bank_card_type: "",
				bank_card_name: "",
			},
			pjson: {
				identity_card1: "",
				identity_card2: "",
				hkb: "",
				zkz: "",
				score: "",
				jiaofei: ""
			},
			imgname: "",
			showbtn: false,
			process_status: ""
		}

	},
	mounted() {
		$(".page").height($(window).height())
		document.title = "退费申请"
		this.pmid = this.$route.query.pmid
		this.openid = this.$route.query.openid
		this.getSchoolName()
		this.checkUrlSign(wx)
		this.getStudents()
	},
	methods: {
		getSchoolName() {
			this.$http.post("/api/app_platform_info", {
				pmid: this.pmid
			}).then(res => {
				this.school_name = res.data.platform
			})
		},
		getStudents() {
			this.$http.post("/api/stuinfo_byopenid", {
				pmid: this.pmid,
				openid: this.openid
			}).then(res => {
				if (!res.data.stu) {
					this.showSearch = true
				} else {
					if (res.data.stu.pjson) {
						res.data.stu.pjson = JSON.parse(res.data.stu.pjson)
						this.pjson = res.data.stu.pjson

					}
					this.stuForm = res.data.stu
					this.showInfo = true
					this.showSearch = false
					this.getTuiFeiInfo(this.stuForm.id)

				}
			})
		},
		getTuiFeiInfo(stuid) {
			this.$http.post("/api/get_stu_tuifei_info", {
				pmid: this.pmid,
				stu_id: stuid,
				year: (new Date().getFullYear())
			}).then(res => {
				if (!res.data) {
					this.showbtn = true
				} else {
					this.tuifei = JSON.parse(res.data.pjson)
					if (res.data.status == 0) {
						this.process_status = "已提交待审核"
					} else if (res.data.status == 1) {
						this.process_status = "退费已审核，待财务确认退费~"
					} else if (res.data.status == 2) {
						this.process_status = "已退费，如未收到退费，请联系学校~"
					} else if (res.data.status == -1) {
						this.process_status = "退费拒绝"
					}
					console.log(this.tuifei)
					if (this.tuifei.ylth) {
						this.YuanluTuihui = this.tuifei.ylth
					} else {
						if (this.tuifei.bank_card_num) {
							this.YuanluTuihui = 2
						} else {
							this.YuanluTuihui = 1
						}
					}
					this.$nextTick(e=>{
						this.$forceUpdate()
					})

				}
			})
		},
		onSearch() {
			this.$http.post("/api/app_luqu_check", {
				stu_name: this.stuForm.stu_name,
				stu_code: this.stuForm.exam_num,
				pmid: this.pmid,
				openid: this.openid
			}).then(res => {

				if (res.data.stu || res.data.status >= 2) {
					this.getStudents()
					this.showSearch = false
				} else if (res.data.id && res.data.status < 3) {
					Toast("该学生无需退费");
					this.showSearch = true
				} else {
					Toast("未找到录取信息！");
					this.showSearch = true
				}

			})
		},

		setImageType(e) {
			this.imgname = e
			this.chooseImageWx()
		},
		chooseImage(e) {

			this.pjson[this.imgname] = e.url
		},
		chooseImageWx() {
			wx.chooseImage({
				count: 1, // 默认9
				sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
				sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
				success: (res) => {
					wx.uploadImage({
						localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
						isShowProgressTips: 1, // 默认为1，显示进度提示
						success: (res2) => {
							var serverId = res2.serverId; // 返回图片的服务器端ID
							this.$http.post("/api/get_wximage", {
								serverId: serverId
							}).then(data => {
								// alert(JSON.stringify(data.data))
								console.log(data.data.url)
								this.chooseImage(data.data)
							})
						}
					});
				}
			});
		},
		saveStu() {
			// console.log(this.stuForm)
			// console.log(this.tuifei)
			if (this.YuanluTuihui == 1) {
				this.tuifei.ylth = this.YuanluTuihui
			} else {
				if (!this.tuifei.bank_card_num) {
					Toast("请输入银行卡卡号");
					return
				}
				if (!this.tuifei.bank_card_type) {
					Toast("请输入银行卡开户行");
					return
				} else if (this.tuifei.bank_card_type.indexOf("支行") < 0) {
					Toast("请输入支行");
					return
				}
				if (!this.tuifei.bank_card_name) {
					Toast("请输入银行卡姓名");
					return
				}
				this.tuifei.ylth = this.YuanluTuihui
			}


			Dialog.confirm({
				title: '退费申请确认',
				message: '确认提交退费申请？退费后所有信息将被退回！',
			})
				.then(() => {
					this.$http.post("/api/save_stu_tuifei_info", {
						pmid: this.pmid,
						form_type: "td",
						stu_id: this.stuForm.id,
						sq_reason: "学生主动申请退费",
						pjson: this.tuifei
					}).then(res => {
						Toast("提交成功，请耐心等待审核");
						this.showbtn = false
						this.process_status = "已提交待审核"
						this.stuForm.pjson = this.pjson
						this.$http.post("/api/h5_save_stumore", this.stuForm).then(res => {


						})
					})
				})
				.catch(() => {
					// on cancel
				});


		}
	}
}
</script>

<style scoped="scoped" lang="less" type="text/less">
.submitBtn {
	margin-top: 2vh;
	margin-bottom: 50px;

	.btn {
		display: inline-block;
		padding: 1.4vh 8%;
		background-color: #00CFDC;
		color: #fff;
		font-size: 15px;
		border-radius: 5vw;
		width: 50%;
		text-align: center;
	}

	.btn:active {

		background-color: #007AFF;

	}
}

.imagebox {
	border: 1px dotted #ccc;
	width: 100px;
	height: 100px;
	background-color: #F2F3F5;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 40px;
	color: #ccc
}
</style>
